var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcJpgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_692_1614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6295 6.62812V21.1078C20.6295 22.7062 19.3357 24 17.7373 24H6.2623C4.66387 24 3.37012 22.7062 3.37012 21.1078V2.89219C3.37012 1.29375 4.66387 0 6.2623 0H14.0014L20.6295 6.62812Z",
    fill: "#50BEE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6296 6.62813H15.1968C14.5358 6.62813 14.0015 6.09375 14.0015 5.43281V0L20.6296 6.62813Z",
    fill: "#82DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75293 15.9187C8.26387 15.9187 8.54043 15.7125 8.54043 15.0421V11.0437H9.22481V15.0421C9.22481 16.05 8.71855 16.5937 7.75293 16.5937V15.9187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8809 12.5812C12.8809 13.5796 12.3512 14.1328 11.4184 14.1328H10.8465V15.8062H10.1621V11.0437H11.4184C12.3512 11.0437 12.8809 11.6109 12.8809 12.5812ZM12.1777 12.5812C12.1777 11.9953 11.9246 11.6953 11.409 11.6953H10.8465V13.4765H11.409C11.9293 13.4765 12.1824 13.1953 12.1777 12.5812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4297 14.3906V12.4546C13.4297 11.489 13.9594 10.9734 14.8219 10.9734C15.6656 10.9734 16.1719 11.4843 16.2094 12.4218H15.5297C15.5016 11.8734 15.2578 11.6343 14.8219 11.6343C14.3859 11.6343 14.1281 11.8875 14.1281 12.464V14.3906C14.1281 14.9671 14.4 15.2203 14.8406 15.2203C15.2953 15.2203 15.5672 14.9671 15.5672 14.4234V13.8281H14.8125V13.214H16.2422V14.4234C16.2281 15.3562 15.6937 15.8765 14.8359 15.8765C13.9781 15.8765 13.4297 15.3562 13.4297 14.3906Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_692_1614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcJpgFile);
export default __webpack_public_path__ + "static/media/ic-jpg-file.7a0bd49e2cf2113391e40149bac2b71a.svg";
export { ForwardRef as ReactComponent };